import { Suspect, Comment } from "../types";

export const EPISODE = {
  number: 1,
  title: "The Guest Room",
  tagline: "A quiet night. A trusted home. A death that shouldn't have been possible.",
  season: "Season 01",
  series: "The Obsidian Club Murders",
  victim: "Ethan Kwan",
  timestamp: "11:07 PM",
  location: "Downtown Washington D.C.",
  crimeDescription:
    "Ethan Kwan arrives at his longtime friend's townhouse. Less than 40 minutes later he is found dead in the guest bedroom. The house was locked from the inside. No forced entry. Three precise stab wounds. Almost no blood at the scene.",
};

export const SUSPECTS: Suspect[] = [
  {
    id: "adrian",
    name: "Adrian Cole",
    role: "Homeowner · Lawyer",
    statement:
      "Ethan arrived, we talked briefly, then I went to my room. I heard nothing until Victor shouted.",
    pct: 28,
  },
  {
    id: "victor",
    name: "Victor Hale",
    role: "Partner · Tech Consultant",
    statement:
      "I found him. There was so little blood… I knew something was wrong immediately.",
    pct: 51,
    guilty: true,
  },
  {
    id: "marcus",
    name: "Marcus Reed",
    role: "Roommate · Night Shift Worker",
    statement:
      "I was downstairs most of the time. I barely even saw Ethan.",
    pct: 21,
  },
];

export const COMMENTS_THEORY: Comment[] = [
  {
    id: 1,
    author: "cold_case_k",
    time: "1h ago",
    avatar: "C",
    text: "Victor said 'there was so little blood' before anyone told him the death was suspicious. How did he know what the blood level should look like?",
    delay: 0,
  },
  {
    id: 2,
    author: "nightowl_77",
    time: "2h ago",
    avatar: "N",
    text: "The 42 minute window is the key. Killing, cleaning, staging a false narrative — that's too much for one person. Adrian and Victor did this together.",
    delay: 0.1,
  },
  {
    id: 3,
    author: "detective_felix",
    time: "3h ago",
    avatar: "D",
    text: "Marcus is too obvious. Missing kitchen knife is practically a neon sign. I'm not buying it.",
    delay: 0.2,
  },
  {
    id: 4,
    author: "reader_28",
    time: "4h ago",
    avatar: "R",
    text: "Victor directed paramedics straight to the guest room. He knew exactly where the body was before he 'found' it.",
    delay: 0.3,
  },
  {
    id: 5,
    author: "sharp_mind",
    time: "5h ago",
    avatar: "S",
    text: "No signs of struggle but three precise wounds with significant force. Ethan trusted whoever walked in. He never saw it coming.",
    delay: 0.4,
  },
];

export const COMMENTS_DISCUSSION: Comment[] = [
  {
    id: 6,
    author: "cold_case_k",
    time: "30m ago",
    avatar: "C",
    text: "The blood comment sealed it for me. Victor knew the scene had been cleaned because he cleaned it.",
    delay: 0,
  },
  {
    id: 7,
    author: "nightowl_77",
    time: "1h ago",
    avatar: "N",
    text: "Called the collaboration but got the trigger wrong. Victor executed it, Adrian planned it. Ethan knew something about one of them.",
    delay: 0.1,
  },
  {
    id: 8,
    author: "detective_felix",
    time: "1h ago",
    avatar: "D",
    text: "Marcus was a plant. The missing knife was there to make us look away from Victor's slip. Ella is a good writer.",
    delay: 0.2,
  },
  {
    id: 9,
    author: "reader_28",
    time: "2h ago",
    avatar: "R",
    text: "Three precise wounds, no struggle. Victor walked in calm. Ethan thought he was safe. That detail is genuinely chilling.",
    delay: 0.3,
  },
];
